export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-16.jpg'),
        title: 'HUMAN RESOURCE',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'HUMAN RESOURCE',
      description:
        `<p style="font-size:1.5rem">Maesinfo high-tech human resources service is to provide customers with various types of high-quality, high-tech talents, including but not limited to various software R&D engineers
</p><p>Our Advantages:<br/>
1) Hi-tech talent service in IT industry at home and abroad<br/>
2)  Melinked.com, a delivery channel for high-tech talent services at home and abroad
</p>`
    },
    {
      title: 'THE VALUE WE BRING TO OUR CUSTOMERS',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-16.jpg')+`)"></span>
      <span class="list">
      <i></i>Hi-tech talent service in IT industry at home and abroad<br/ >
      <i></i> Melinked.com, a delivery channel for high-tech talent services at home and abroad

      </span>`
    }
  ]
}
